<template>
	<div class="legal">
		<div class="container">
			<UIHeading level="3" class="legal__title">
				{{ $t('pages.legal.title') }}
			</UIHeading>
			<div class="legal__content">
				<ul class="legal__list">
					<li class="legal__item">
						<a
							:href="`/files/veon-partners-privacy-policy-${$i18n.locale}.pdf`"
							target="_blank"
							class="legal__link">
							{{ $t('pages.legal.list.item0') }}
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	const { $ScrollTrigger: ScrollTrigger } = useNuxtApp()

	onMounted(() => {
		ScrollTrigger.refresh()
	})
</script>

<style scoped lang="scss">
	.legal {
		padding-top: 100px;
		padding-bottom: 100px;
		background-color: #000000;
		&__title {
			color: var(--white);
		}
		&__content {
			padding: 20px;
			margin-top: 32px;
			color: var(--white);
			background-color: #1d1d1d;
			border-radius: 10px;

			// min-height: 300px;
		}
		&__link {
			text-decoration: underline;
			&:hover {
				text-decoration: none;
			}
		}
	}
</style>
